import * as React from 'react'

const Response = ({ children }: React.PropsWithChildren) => (
  <p className="sp-text-survey-text-user sp-break-words">{children}</p>
)

export default Response
